import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-up\"><path d=\"M11.293 8.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L12 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol